import { render, staticRenderFns } from "./DesignRirekisho001Preview.vue?vue&type=template&id=d9079c74&scoped=true"
import script from "./DesignRirekisho001Preview.vue?vue&type=script&lang=js"
export * from "./DesignRirekisho001Preview.vue?vue&type=script&lang=js"
import style0 from "./DesignRirekisho001Preview.vue?vue&type=style&index=0&id=d9079c74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9079c74",
  null
  
)

export default component.exports